var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal2",
    {
      attrs: {
        visible: true,
        showTitle: false,
        showFooter: false,
        large: true,
        className: "ai-assistant-modal",
      },
      on: { cancel: _vm.handleCancel },
    },
    [
      _c("div", { staticClass: "mail-ai-assistant" }, [
        _vm.isLoading
          ? _c("div", { staticClass: "loading-overlay" }, [
              _c("div", { staticClass: "loading-container" }, [
                _c("div", { staticClass: "ai-brain" }, [
                  _c("i", { staticClass: "material-icons animate-pulse" }, [
                    _vm._v("psychology"),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "loading-text" }, [
                  _vm._v(_vm._s(_vm.$t("mail.mailAiAssistant.loadingText"))),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "loading-description" }, [
                  _vm._v(
                    _vm._s(_vm.$t("mail.mailAiAssistant.loadingDescription"))
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "loading-dots" }, [
                  _c("span"),
                  _vm._v(" "),
                  _c("span"),
                  _vm._v(" "),
                  _c("span"),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.mode === "menu" &&
        !_vm.showSentimentResult &&
        !_vm.showPreviewResult &&
        !_vm.showSubOptions &&
        !_vm.showCustomPromptScreen
          ? _c("div", { staticClass: "assistant-dashboard" }, [
              _c("div", { staticClass: "ai-assistant-header" }, [
                _c("div", { staticClass: "ai-logo" }, [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("psychology"),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "ai-title-container" }, [
                  _c("h2", [
                    _vm._v(_vm._s(_vm.$t("mail.mailAiAssistant.aiTitle"))),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "ai-description" }, [
                    _vm._v(
                      _vm._s(_vm.$t("mail.mailAiAssistant.aiDescription")) +
                        "\n                    "
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "feature-cards" },
                [
                  !_vm.hasContent && _vm.filteredMenuItems.length === 0
                    ? _c("div", { staticClass: "empty-state" }, [
                        _c("div", { staticClass: "empty-icon" }, [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("email_off"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("h3", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("mail.mailAiAssistant.emptyContentTitle")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "mail.mailAiAssistant.emptyContentDescription"
                              )
                            )
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.filteredMenuItems, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "feature-card",
                        on: {
                          click: function ($event) {
                            return _vm.handleOptionClick(item)
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "card-icon" }, [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v(_vm._s(item.icon)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "card-content" }, [
                          _c("h3", [_vm._v(_vm._s(item.title))]),
                          _vm._v(" "),
                          item.description
                            ? _c("p", [_vm._v(_vm._s(item.description))])
                            : _vm._e(),
                        ]),
                      ]
                    )
                  }),
                ],
                2
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.showSubOptions &&
        !_vm.showSentimentResult &&
        !_vm.showPreviewResult &&
        !_vm.showCustomPromptScreen
          ? _c("div", { staticClass: "sub-menu-screen" }, [
              _c("div", { staticClass: "sub-menu-header" }, [
                _c(
                  "button",
                  {
                    staticClass: "back-button",
                    on: {
                      click: function ($event) {
                        _vm.showSubOptions = false
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("arrow_back"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.$t("message.back")))]),
                  ]
                ),
                _vm._v(" "),
                _c("h3", [_vm._v(_vm._s(_vm.currentOptionTitle))]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "sub-options-container" },
                [
                  !_vm.hasContent && _vm.filteredSubOptions.length === 0
                    ? _c("div", { staticClass: "empty-state" }, [
                        _c("div", { staticClass: "empty-icon" }, [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("email_off"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("h3", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("mail.mailAiAssistant.emptyContentTitle")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "mail.mailAiAssistant.emptyContentDescription"
                              )
                            )
                          ),
                        ]),
                      ])
                    : !_vm.hasContent && _vm.filteredSubOptions.length > 0
                    ? _c("div", { staticClass: "limited-access-banner" }, [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("info"),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "mail.mailAiAssistant.limitedAccessDescription"
                              )
                            )
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.filteredSubOptions, function (option, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "sub-option-card",
                        on: {
                          click: function ($event) {
                            return _vm.handleSubOptionClick(option)
                          },
                        },
                      },
                      [
                        option.icon
                          ? _c("div", { staticClass: "option-icon" }, [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v(_vm._s(option.icon)),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "option-content" }, [
                          _c("h4", [_vm._v(_vm._s(option.title))]),
                          _vm._v(" "),
                          option.description
                            ? _c("p", [_vm._v(_vm._s(option.description))])
                            : _vm._e(),
                        ]),
                      ]
                    )
                  }),
                ],
                2
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        (_vm.showSentimentResult || _vm.mode === "sentiment") &&
        !_vm.showSubOptions &&
        !_vm.showPreviewResult &&
        !_vm.showCustomPromptScreen
          ? _c("div", { staticClass: "results-screen" }, [
              _c("div", { staticClass: "results-container" }, [
                _c("div", { staticClass: "sentiment-summary" }, [
                  _c(
                    "div",
                    {
                      staticClass: "sentiment-badge",
                      class: _vm.sentimentResult.tone.toLowerCase(),
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.sentimentResult.tone === "Pozitif"
                                ? "sentiment_very_satisfied"
                                : _vm.sentimentResult.tone === "Negatif"
                                ? "sentiment_very_dissatisfied"
                                : _vm.sentimentResult.tone === "Karışık"
                                ? "sentiment_neutral"
                                : "sentiment_neutral"
                            ) +
                            "\n                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.sentimentResult.tone))]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "result-section emotions-section" }, [
                  _c("h4", [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("psychology"),
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("mail.mailAiAssistant.resultEmotions"))
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "emotions-tags" },
                    _vm._l(
                      _vm.sentimentResult.emotions,
                      function (emotion, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "emotion-tag" },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(emotion) +
                                "\n                        "
                            ),
                          ]
                        )
                      }
                    ),
                    0
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "result-section explanation-section" },
                  [
                    _c("h4", [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("info"),
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("mail.mailAiAssistant.analysisDescription")
                          )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.sentimentResult.explanation))]),
                  ]
                ),
                _vm._v(" "),
                _vm.sentimentResult.recommendations &&
                _vm.sentimentResult.recommendations.length > 0
                  ? _c(
                      "div",
                      { staticClass: "result-section recommendations-section" },
                      [
                        _c("h4", [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("lightbulb"),
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "mail.mailAiAssistant.recommendationsList"
                                )
                              )
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "recommendations-list" },
                          _vm._l(
                            _vm.sentimentResult.recommendations,
                            function (recommendation, index) {
                              return _c("li", { key: index }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(recommendation) +
                                    "\n                        "
                                ),
                              ])
                            }
                          ),
                          0
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        (_vm.showPreviewResult || _vm.mode === "summarize") &&
        !_vm.showSubOptions &&
        !_vm.showSentimentResult &&
        !_vm.showCustomPromptScreen
          ? _c("div", { staticClass: "preview-screen" }, [
              _c("div", { staticClass: "preview-header" }, [
                _c(
                  "button",
                  {
                    staticClass: "back-button",
                    on: { click: _vm.handlePreviewBack },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v(
                        _vm._s(_vm.useCloseButton ? "close" : "arrow_back")
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.useCloseButton
                            ? _vm.$t("message.close")
                            : _vm.$t("message.back")
                        )
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("h3", [
                  _vm._v(
                    _vm._s(
                      _vm.previewTitle ||
                        (_vm.mode === "summarize"
                          ? _vm.$t("mail.mailAiAssistant.mailSummarize")
                          : "")
                    )
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "preview-container" }, [
                _c("div", { staticClass: "ai-response-box" }, [
                  _c("div", { staticClass: "response-header" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("smart_toy"),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("mail.mailAiAssistant.aiResponse"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "response-content" }, [
                    _c("div", {
                      domProps: { innerHTML: _vm._s(_vm.previewContent) },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                !_vm.useCloseButton
                  ? _c("div", { staticClass: "action-buttons" }, [
                      _c(
                        "button",
                        {
                          staticClass: "action-button regenerate",
                          on: { click: _vm.regenerateContent },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("refresh"),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("mail.mailAiAssistant.rebuild"))
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "action-button apply",
                          on: { click: _vm.applyPreviewContent },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("check_circle"),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("mail.mailAiAssistant.applyText"))
                            ),
                          ]),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.showCustomPromptScreen &&
        !_vm.showSubOptions &&
        !_vm.showSentimentResult &&
        !_vm.showPreviewResult
          ? _c("div", { staticClass: "custom-prompt-screen" }, [
              _c("div", { staticClass: "custom-prompt-header" }, [
                _c(
                  "button",
                  {
                    staticClass: "back-button",
                    on: {
                      click: function ($event) {
                        _vm.showCustomPromptScreen = false
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("arrow_back"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.$t("message.back")))]),
                  ]
                ),
                _vm._v(" "),
                _c("h3", [
                  _vm._v(_vm._s(_vm.$t("mail.mailAiAssistant.specialRequest"))),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "custom-prompt-container" },
                [
                  _c("S2Textarea", {
                    attrs: {
                      placeholder: _vm.$t(
                        "mail.mailAiAssistant.specialRequestPlaceholder"
                      ),
                      showAITool: false,
                    },
                    model: {
                      value: _vm.customPrompt,
                      callback: function ($$v) {
                        _vm.customPrompt = $$v
                      },
                      expression: "customPrompt",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "action-button apply",
                      on: { click: _vm.handleCustomPrompt },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("check_circle"),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("mail.mailAiAssistant.sendRequest"))
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }